import { withRouter } from 'react-router-dom';
import React, { Component } from "react";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "../../View.jsx";
import ViewUtils from '../../ViewUtils';
import ExtensionSearchForm from './ExtensionSearchForm';
import EnhancedToolbar from '../../widgets/Toolbar';
import EnhancedTable from '../../widgets/ResponsiveTable';
import AddDialog from './ExtensionRequestDialog';
import AlertItem from "../../widgets/AlertItem";
import EditDialog from './RequestExtensionEditDialog';
import Prompt from '../../widgets/Prompt';
import withMenuPermission from "../../widgets/withMenuPermission";

const utils = new ViewUtils();
const toolbarRef = React.createRef();

const headCells = [
    { id: 'Date', numeric: false, disablePadding: true, label: 'Date' },
    { id: 'Time', numeric: false, disablePadding: true, label: 'Time' },
    { id: 'LoggedBy', numeric: false, disablePadding: true, label: 'Logged By' },
    { id: 'Letterhead', numeric: false, disablePadding: true, label: 'Letterhead' },
    { id: 'AuthorisedSignatory', numeric: false, disablePadding: true, label: 'Authorise signatory' },
    { id: 'Reasons', numeric: false, disablePadding: true, label: 'Reason' },
    { id: 'AppealStatus', numeric: false, disablePadding: true, label: 'Apeal Status' },
    { id: 'Document', numeric: false, disablePadding: true, label: 'Document', contentType: 'document' },
    { id: 'DateCommunicationGenerated', numeric: false, disablePadding: true, label: 'Date Communication Generated' },
];

class RequestExtension extends Component {
    constructor(props) {
        super(props);
        this.state = {
            model: { Id: this.props.location.state.selection },
            addDialogOpen: false,
            editDialogOpen: false,
            selectedId: null,
            searchParameters: [
                { Name: "OrganisationID", Value: this.props.location.state.organisationID }, 
                { Name: "FinancialYearID", Value: 0 }
            ],
            FinancialYearID: null,
            clearSelectedRow: false,
            promptOpen: false,
            promptTitle: "Remove Request Extension",
            promptContent: "Are you sure you want to remove this Request Extension?",
            Extension: false, // This controls visibility
            Message: "",
            MessageStyle: ""
        };
    }

    // Sync button disabled states via Ref
    syncToolbarButtons = () => {
        const isSelectionEmpty = utils.isNull(this.state.selectedId);
        const isYearEmpty = utils.isNull(this.state.FinancialYearID);

        if (this.state.Extension && toolbarRef.current) {
            // Delay to allow DOM to catch up after potential re-render
            setTimeout(() => {
                if (toolbarRef.current) {
                    toolbarRef.current.setButtonDisabled("add", isYearEmpty);
                    toolbarRef.current.setButtonDisabled("edit", isSelectionEmpty);
                    toolbarRef.current.setButtonDisabled("remove", isSelectionEmpty);
                }
            }, 100);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedId !== this.state.selectedId || 
            prevState.FinancialYearID !== this.state.FinancialYearID ||
            prevState.Extension !== this.state.Extension) {
            this.syncToolbarButtons();
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "add") this.setState({ addDialogOpen: true });
        else if (buttonId === "edit") this.setState({ editDialogOpen: true });
        else if (buttonId === "close") {
            this.props.history.push({
                pathname: "/skillsOrganisation",
                state: { selection: this.props.location.state.organisationID }
            });
        }
        else if (buttonId === "remove") this.setState({ promptOpen: true });
    }

    handleFormValueChange(values) {
        const FinancialYearID = (values && values.FinancialYear && values.FinancialYear.Id) ? values.FinancialYear.Id : null;
        let newsearchParameters = [...this.state.searchParameters];
        newsearchParameters[1] = { ...newsearchParameters[1], Value: FinancialYearID };

        this.setState({
            searchParameters: JSON.parse(JSON.stringify(newsearchParameters)),
            FinancialYearID: FinancialYearID,
            selectedId: null,
            clearSelectedRow: true
        }, () => {
            if (FinancialYearID) {
                this.CheckExtensionPermissions(FinancialYearID);
            } else {
                this.setState({ Extension: false });
            }
        });
    }

    CheckExtensionPermissions(FinancialYearID) {
        let url = "api/sims/requestextension/GetWSPATRExtensionPermissionCheck?OrganisationID=" + 
                  this.props.location.state.organisationID + "&FinancialYearID=" + FinancialYearID;

        utils.invokeUrl(url, (response) => {
            // FIX: Explicitly check for string "true" or boolean true
            const canShowExtension = response.Result === true || response.Result === "true";

            this.setState({ Extension: canShowExtension }, () => {
                if (canShowExtension) {
                    this.syncToolbarButtons();
                }
            });
        }, null, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + localStorage.getItem("token")
            }
        });
    }

    handleSelectionChange = (selection) => {
        if (selection && selection.length !== 0) {
            this.setState({ selectedId: selection[0].Id, Message: "", clearSelectedRow: false });
        } else {
            this.setState({ selectedId: null, Message: "", clearSelectedRow: false });
        }
    }

    FileDownload = (rowid, headCell) => {
        if (headCell.contentType === "document") {
            utils.invokeUrl("api/sims/requestextension/downloaddocument?id=" + rowid, (response) => {
                var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
                var url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = response.Name;
                link.target = '_blank';
                link.click();
            }, () => {
                this.setState({ Message: utils.SYSTEM_ERROR_MESSAGE, MessageStyle: "outlinedError" });
            });
        }
    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    postAddHandler(cancel, save, response) {
        if (save === true) {
            this.setState({
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters)),
                addDialogOpen: false,
                editDialogOpen: false,
                selectedId: null,
                Message: response.Message,
                MessageStyle: response.MessageType === "SUCCESS" ? "success" : "warning",
                clearSelectedRow: true
            });
        } else if (cancel === true) {
            this.setState({ addDialogOpen: false, editDialogOpen: false, selectedId: null, clearSelectedRow: true });
        }
    }

    remove(url) {
        this.setState({ promptOpen: false, clearSelectedRow: true, selectedId: null });
        let fullUrl = url + "?id=" + this.state.selectedId;
        utils.invokeUrlDelete(fullUrl, this.successfulRemoveCallback, this.unsuccessfulRemoveCallback);
    }

    closePrompt = () => this.setState({ promptOpen: false, clearSelectedRow: true, selectedId: null });

    successfulRemoveCallback = (response) => {
        if (!utils.isNull(response.EntityId) && response.EntityId === 0) {
            this.setState({
                selectedId: null, Message: response.Message, MessageStyle: response.MessageType.toLowerCase(),
                clearSelectedRow: true,
                searchParameters: JSON.parse(JSON.stringify(this.state.searchParameters))
            });
        }
    }

    unsuccessfulRemoveCallback = (response) => {
        if (!utils.isNull(response.Message) && response.Message !== "") {
            this.setState({ Message: response.Message, MessageStyle: response.MessageType.toLowerCase() });
        }
    }

    onClearSelectedRow = () => this.setState({ clearSelectedRow: false });

    render() {
        const isYearEmpty = utils.isNull(this.state.FinancialYearID);
        const isSelectionEmpty = utils.isNull(this.state.selectedId);

        let toolbarItems = [
            {
                type: "buttonGroup",
                buttons: [{ id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }]
            },
            { type: "devider" }
        ];

        // Strict boolean check
        if (this.state.Extension === true) {
            toolbarItems.push({
                type: "buttonGroup",
                buttons: [
                    { 
                        id: 'add', label: '', tooltip: 'Add Request', 
                        disabled: isYearEmpty, 
                        icon: 'AddIcon', visible: this.props.menuPermissionItem.Add 
                    },
                    { 
                        id: 'edit', label: '', tooltip: 'Edit Request', 
                        disabled: isSelectionEmpty, 
                        icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit 
                    },
                    { 
                        id: 'remove', label: '', tooltip: 'Remove Request', 
                        disabled: isSelectionEmpty, 
                        icon: 'DeleteIcon', visible: this.props.menuPermissionItem.Delete 
                    }
                ]
            });
        }

        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="legend">
                    {"Organisation > Request an Extension " + 
                    (this.props.location.state.organisationName !== null ? 
                    "> " + this.props.location.state.organisationName + 
                    (this.props.location.state.sdlnumber !== null ? " - " + this.props.location.state.sdlnumber : "") : "> Add")}
                </p>

                <AlertItem message={this.state.Message} alertStyle={this.state.MessageStyle} />

                <div className="searchResults">
                    <ExtensionSearchForm valueChangeHandler={(values) => this.handleFormValueChange(values)} />

                    <EnhancedToolbar 
                        key={this.state.Extension ? "show-ext" : "hide-ext"} // Forces re-mount when permission changes
                        highlight={false}
                        title="Request an Extension"
                        buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                        ref={toolbarRef}
                        config={{ items: toolbarItems }}
                    />

                    <EnhancedTable
                        headCells={headCells}
                        onSelectionChange={(selection) => this.handleSelectionChange(selection)}
                        dataUrl="api/sims/requestextension/GetSearch"
                        searchParameters={this.state.searchParameters}
                        onCellSelectionChange={(rowid, headCell) => { this.FileDownload(rowid, headCell) }}
                        clearSelectedRow={this.state.clearSelectedRow} 
                        onClearSelectedRow={this.onClearSelectedRow}
                        paged={true} 
                    />
                </div>

                <AddDialog
                    open={this.state.addDialogOpen}
                    FinancialYearID={this.state.FinancialYearID}
                    closeHandler={(cancel, save, response) => this.postAddHandler(cancel, save, response)}
                    viewRef={this}
                    OrganisationID={this.props.location.state.organisationID}
                />

                <EditDialog
                    open={this.state.editDialogOpen}
                    id={this.state.selectedId}
                    closeHandler={(cancel, save, response) => this.postAddHandler(cancel, save, response)}
                    viewRef={this}
                />

                <Prompt 
                    open={this.state.promptOpen}
                    promptTitle={this.state.promptTitle}
                    promptContent={this.state.promptContent}
                    handleYes={() => { this.remove("api/sims/requestextension/removerequestextension") }}
                    closePrompt={this.closePrompt}
                />
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(RequestExtension));